module.exports = __webpack_public_path__ + "static/media/hs_17.dbb51547.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/heads/JPEG/hs_17.jpg
// module id = 5948
// module chunks = 0